import { useState, useEffect, useCallback, useMemo } from "react";
import EditIcon from "@mui/icons-material/Edit";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./profiletitle.css";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import Qrmodal from "@/components/QRmodal/Qrmodal";
import LocationModal from "@/components/locationmodal/LocationModal";
import Desmodal from "@/components/Des_Modal";
import { useLocation, useNavigate } from "react-router-dom";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import EmailIcon from "@mui/icons-material/Email";
import { useSelector } from "react-redux";
import { SuccessNotify, FailedNotify } from "@/constants/tostify";
import {
  useSendConnectionRequestMutation,
  useAcceptConnectionRequestMutation,
} from "@/features/connection/connectionApiSlice";
import { useCheckMarketerForQuery } from "@/features/user/userApiSlice";
import Subscriptionmdl from "@/components/subscription_modal/index";
import { encryptMarketerId } from "@/utils/marketerIdCrypto";

const Profiletitle = ({
  inputChange,
  userDatahandler,
  infooo,
  id,
  checkconnect,
  createShop, // <-- Pass createShop from parent
  connectionStatus = "Connect",
  refetchVisit,
}) => {
  const [isOpen, setOpen] = useState(false); // controls Edit Modal
  const [mshow, setMshow] = useState(false);
  const [showmodal, setShowmodal] = useState(false);
  const [desshow, setDesshow] = useState(false);
  const location = useLocation();

  const isOtherProfile =
    location.pathname.startsWith("/other-profile") ||
    Boolean(
      id &&
        location.pathname !== "/user-profile" &&
        location.pathname !== "/marketing-profile",
    );

  // Subscription modal state
  const [lgShow, setLgShow] = useState(false);
  const [purchase, setPurchase] = useState(false);
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);

  const closemodal = useCallback(() => setShowmodal(false), []);
  const handleClose = useCallback(() => setMshow(false), []);
  const handleClosedes = useCallback(() => setDesshow(false), []);
  const handleShowdes = useCallback(() => setDesshow(true), []);

  const toggleEditModal = useCallback(() => setOpen((prev) => !prev), []);

  const [sendConnectionRequest, { isLoading: isSending }] =
    useSendConnectionRequestMutation();
  const [acceptConnectionRequest, { isLoading: isAccepting }] =
    useAcceptConnectionRequestMutation();

  /** Single derived busy flag — no separate `loading` state needed */
  const isBusy = isSending || isAccepting;

  const handleSendRequest = useCallback(async () => {
    if (!name?._id || !id) {
      FailedNotify("Invalid user data");
      return;
    }

    const searchParams = new URLSearchParams(location.search);
    const prev = localStorage.getItem("previousRoute");
    const marketerSession =
      !!localStorage.getItem("MeAsmarketerId") &&
      (prev === "marketing-clients" ||
        prev === "marketing-profile" ||
        prev === "marketing-dashboard" ||
        location.pathname === "/marketing-profile");
    const isMarketerProfile =
      location.pathname === "/marketing-profile" ||
      searchParams.get("isMarketerProfile") === "true" ||
      marketerSession;

    const payload = {
      senderid: name._id,
      senderBusinessType: isMarketerProfile
        ? "marketerProfile"
        : (name?.businessType ?? "generalPublic"),
      businessType: infooo?.businessType ?? "generalPublic",
      recieverid: id,
      ...(isMarketerProfile ? { asMarketerProfile: true } : {}),
    };

    try {
      await sendConnectionRequest(payload).unwrap();
      SuccessNotify("Connection request sent successfully");
      refetchVisit?.();
    } catch (error) {
      const backendMessage =
        error?.data?.message ??
        error?.data?.error ??
        error?.message ??
        "Request failed";
      if (backendMessage.toLowerCase().includes("limit exceeded")) {
        FailedNotify(backendMessage);
        setLgShow(true);
      } else {
        FailedNotify(backendMessage);
      }
    }
  }, [name, id, infooo, location, sendConnectionRequest, refetchVisit]);

  /* ==================== ACCEPT CONNECTION REQUEST ==================== */
  const handleAcceptRequest = useCallback(async () => {
    if (!name?._id || !id) {
      FailedNotify("Invalid user data");
      return;
    }

    // BTs here are fallbacks only — server accept prefers the pending/requested
    // row's original senderBusinessType / businessType (keeps marketerProfile).
    const payload = {
      senderid: id,
      senderBusinessType: infooo?.businessType ?? "generalPublic",
      businessType: name?.businessType ?? "generalPublic",
      recieverid: name._id,
    };

    try {
      await acceptConnectionRequest(payload).unwrap();
      SuccessNotify("Connection request accepted");
      refetchVisit?.();
    } catch (error) {
      FailedNotify(
        error?.data?.message ??
          error?.data?.error ??
          error?.message ??
          "Accept failed",
      );
    }
  }, [name, id, infooo, acceptConnectionRequest, refetchVisit]);

  const [isMarketerFor, setIsMarketerFor] = useState(
    () => localStorage.getItem("MarketerFor") ?? "", // initialise from storage once
  );
  const [marketerIdDisplay, setMarketerIdDisplay] = useState(
    () => localStorage.getItem("MeAsmarketerId") ?? "",
  );

  const { data: marketerData, isSuccess } = useCheckMarketerForQuery(
    name?._id,
    {
      skip: !name?._id,
    },
  );

  useEffect(() => {
    if (!isSuccess) return;

    const ind = marketerData?.data?.MIndustryName?.[0];
    const marfor = ind?.name || ind || "";
    const rawId = marketerData?.data?.encryptedMarketerId || marketerData?.data?.marketerId || marketerData?.data?._id || "";
    const mId = encryptMarketerId(rawId);

    if (marfor) {
      localStorage.setItem("MarketerFor", marfor);
      setIsMarketerFor(marfor);
    }
    if (mId) {
      localStorage.setItem("MeAsmarketerId", mId);
      setMarketerIdDisplay(mId);
    }
  }, [isSuccess, marketerData]);

  const formattedUserName = useMemo(() => {
    if (!infooo?.fullname || !infooo?._id) return "";
    return `${infooo.fullname.toLowerCase().replace(/\s+/g, "_")}_${infooo._id.slice(-3)}`;
  }, [infooo?.fullname, infooo?._id]);

  const descriptionText = useMemo(() => {
    if (!infooo) return "";
    return typeof infooo.description === "string"
      ? infooo.description
      : (infooo.description?.text ?? "");
  }, [infooo?.description]);

  return (
    <>
      {/* Subscription Modal */}
      <Subscriptionmdl
        lgShow={lgShow}
        setLgShow={setLgShow}
        setPurchase={setPurchase}
        purchase={purchase}
      />

      {/* Description Modal */}
      <Desmodal
        desshow={desshow}
        handleClosedes={handleClosedes}
        des={descriptionText}
      />

      {/* Location Modal */}
      <LocationModal mshow={mshow} handleClose={handleClose} />

      {/* QR Modal */}
      <Qrmodal show={showmodal} handleClosemodal={closemodal} />

      {/* Edit Description Modal */}
      <Modal show={isOpen} onHide={toggleEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Description</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="text" // must match createShop field
                value={createShop?.text || ""} // ✅ controlled input
                onChange={inputChange} // updates createShop.text in parent
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              userDatahandler(); // save updated description
              toggleEditModal();
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Profile Header */}
      <Row className="gb profile-header-row">
        <Col xl={3} lg={3} md={3} sm={4} xs={4} className="profile-header-spacer">
          <div className="emptydiv"></div>
        </Col>

        <Col xl={9} lg={9} md={9} sm={8} xs={8} className="profile-header-content">
          <Row className="bb profile-header-main pb-3">
            <Col
              xl={isOtherProfile ? 5 : 7}
              lg={isOtherProfile ? 5 : 9}
              md={6}
              sm={12}
              xs={12}
              className="profile-header-info"
            >
              <div className="extraset userid_setting">
                <div className="mt-2">
                  <div className="d-flex align-items-center">
                    <h4 className="m-0">{infooo?.fullname}</h4>
                    {/* Edit Icon only for user profile */}
                    {location.pathname === "/user-profile" && (
                      <div className="pen_cls">
                        <EditIcon onClick={toggleEditModal} />
                      </div>
                    )}
                  </div>

                  <div>
                    {location.pathname === "/marketing-profile" ? (
                      <p className="m-0 mt-3 font_13">
                        Marketing Expert For : <b>{isMarketerFor}</b>
                      </p>
                    ) : (
                      <>
                        <p className="shop-profile-para mb-0 mt-1">
                          {descriptionText?.slice(0, 30)}
                        </p>
                        {descriptionText?.length > 30 && (
                          <span
                            onClick={handleShowdes}
                            className="cursor_P font_11"
                          >
                            <b>ReadMore...</b>
                          </span>
                        )}
                      </>
                    )}
                  </div>
                </div>

                <p className="extrauseridset">
                  <b>User Name :</b> {formattedUserName || infooo?._id}
                </p>
                {location.pathname === "/marketing-profile" && (
                  <p className="m-0 mt-3 font_13">
                    <b>Marketer ID :</b> {marketerIdDisplay}
                  </p>
                )}
              </div>
            </Col>

            <Col
              xl={isOtherProfile ? 7 : 5}
              lg={isOtherProfile ? 7 : 3}
              md={6}
              sm={12}
              xs={12}
              className="profile-header-actions"
            >
              {location.pathname === "/user-profile" ||
              location.pathname === "/marketing-profile" ? (
                <div className="QRandbtn profile-header-tools mt-2">
                  <QrCode2Icon
                    style={{ fontSize: "50px" }}
                    onClick={() => setShowmodal(true)}
                  />

                  <button
                    onClick={() =>
                      navigate(
                        `/connection-request/${name?._id}${
                          location.pathname === "/marketing-profile"
                            ? "?isMarketerProfile=true"
                            : ""
                        }`,
                      )
                    }
                    className="btn text-white mt-4 font_13 me-1 p-2"
                    style={{ backgroundColor: "#0353a4" }}
                  >
                    View Connection Request
                  </button>
                </div>
              ) : (
                <div className="profile-connection-actions">
                  {checkconnect !== true && (
                    <>
                      {connectionStatus === "Connect" && (
                        <button
                          type="button"
                          className="profile-action-btn profile-action-btn-primary"
                          disabled={isBusy}
                          onClick={handleSendRequest}
                        >
                          <PersonAddIcon className="profile-action-btn-icon" />
                          <span>{isBusy ? "Sending..." : "Send Request"}</span>
                        </button>
                      )}
                      {connectionStatus === "Pending" && (
                        <button
                          type="button"
                          className="profile-action-btn profile-action-btn-primary is-pending"
                          disabled
                        >
                          <PersonAddIcon className="profile-action-btn-icon" />
                          <span>Pending</span>
                        </button>
                      )}
                      {connectionStatus === "Accept" && (
                        <button
                          type="button"
                          className="profile-action-btn profile-action-btn-primary"
                          disabled={isBusy}
                          onClick={handleAcceptRequest}
                        >
                          <PersonAddIcon className="profile-action-btn-icon" />
                          <span>{isBusy ? "Accepting..." : "Accept Request"}</span>
                        </button>
                      )}
                    </>
                  )}
                  {connectionStatus === "Connected" && (
                    <button
                      type="button"
                      className="profile-action-btn profile-action-btn-primary is-connected"
                      disabled
                    >
                      <PersonAddIcon className="profile-action-btn-icon" />
                      <span>Friends</span>
                    </button>
                  )}
                  {checkconnect === true && (
                    <button
                      type="button"
                      className="profile-action-btn profile-action-btn-silver me-1"
                      onClick={() => {
                        // Store target user info and fire open-messenger event
                        const targetUser = {
                          _id: infooo?._id,
                          fullname: infooo?.fullname,
                          image:
                            infooo?.imageUrl?.[0] || infooo?.profilePic || null,
                          position: "User",
                          businessType: "generalPublic",
                        };
                        localStorage.setItem(
                          "messengerTargetUser",
                          JSON.stringify(targetUser),
                        );
                        window.dispatchEvent(
                          new CustomEvent("open-messenger", {
                            detail: targetUser,
                          }),
                        );
                      }}
                    >
                      <EmailIcon className="profile-action-btn-icon" />
                      <span>Send Message</span>
                    </button>
                  )}
                </div>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Profiletitle;
